import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import CheckGroupField from './CheckGroupField';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';

type CheckOption = {
  label: string;
  value: string;
  disabled?: boolean;
};

interface CheckGroupProps extends IClassNames {
  options: CheckOption[];
  name: string;
  id?: string;
  label: string;
  description?: string;
  required?: boolean;
}

const CheckGroup: React.FC<CheckGroupProps> = ({
  name,
  label,
  options,
  id,
  classNames,
  description,
  required = true,
  ...props
}) => {
  const { className } = useClassNames(classNames, 'a-input', 'ckp-m-check-group');

  return (
    <fieldset className={className} {...props}>
      <legend className="a-input__label ckp-m-check-group__label">
        {label}
        {required && <span className="u-text-danger"> *</span>}
      </legend>

      {options.map((option, index) => {
        const htmlId = uuidv4();

        return (
          <div
            key={`checkbox_${index} + option.value`}
            className="filter__checkbox u-margin-bottom-s"
          >
            <CheckGroupField option={option} htmlId={htmlId} name={name} />
          </div>
        );
      })}

      {description && <small>{description}</small>}
    </fieldset>
  );
};

export default CheckGroup;
